import React from 'react';
import { toast } from 'react-toastify';
import { actions } from 'react-redux-form';
import irelandApi from '../irelandApi';
import {
  ADD_ADMIN_GAME_FULFILLED,
  ADD_ADMIN_GAME_PENDING,
  ADD_ADMIN_GAME_REJECTED,
  GET_ADMIN_GAMES_FULFILLED,
  GET_ADMIN_GAMES_PENDING,
  GET_ADMIN_GAMES_REJECTED,
  GET_ADMIN_GAME_FULFILLED,
  GET_ADMIN_GAME_META_FULFILLED,
  GET_ADMIN_GAME_META_PENDING,
  GET_ADMIN_GAME_META_REJECTED,
  GET_ADMIN_GAME_PENDING,
  GET_ADMIN_GAME_REJECTED,
  GET_GAME_BACKGROUND_URL_FULFILLED,
  GET_GAME_BACKGROUND_URL_PENDING,
  GET_GAME_BACKGROUND_URL_REJECTED,
  UPDATE_ADMIN_GAME_FULFILLED,
  UPDATE_ADMIN_GAME_PENDING,
  UPDATE_ADMIN_GAME_REJECTED
} from '../reducers/gamesReducer';
import ToastMessage from '../components/common/toast-message';
import store, { history } from '../store';

const url = '/api/admin';

const config = {
  headers: { 'content-type': 'multipart/form-data' }
};

const prepareGameFormData = (payload) => {
  const formData = new FormData();
  const { group_ids, product_ids, ...rest } = payload;
  const hasNoLevels = payload['has_no_levels'];

  Object.keys(rest).forEach(key => {
    if (!hasNoLevels && (['prize_amount', 'game_link'].includes(key))) {
      return;
    }

    formData.append(`game[${key}]`, rest[key]);
  });

  group_ids.map((group) => +group.value).forEach((groupId) => {
    formData.append('game[group_ids][]', groupId);
  })

  product_ids.map((product) => +product.value).forEach((productId) => {
    formData.append('game[product_ids][]', productId);
  });
 
  if (!hasNoLevels) {
    const { game_levels: gameLevels } = payload;
    const gameLevelsAttributes = Object.entries(gameLevels).map((gameLevel) => {
      const level = +gameLevel[0].split('-')[1];
      const values = gameLevel[1];
  
      if (values['_destroy'] && values['id']) {
        return {
          id: values['id'].value,
          _destroy: 1
        }
      }
  
      return {
        level,
        id: values['id'] ? +values['id'].value : null,
        minimum_number_of_outers: +values['minimum-number-of-outers'].value,
        prize_amount: +values['prize-amount'].value,
        game_name: values['game-name'].value
      }
    });

    gameLevelsAttributes.forEach((gameLevelsAttribute) => {
      formData.append('game[game_levels_attributes][]', JSON.stringify(gameLevelsAttribute));
    });
  }

  formData.delete('links');
  formData.delete('game_levels');

  return formData;
};

export const getAdminGameMeta = () => (dispatch) => {
  dispatch({ type: GET_ADMIN_GAME_META_PENDING });

  return irelandApi.get(`${url}/games/new`)
    .then((response) => {
      dispatch({
        type: GET_ADMIN_GAME_META_FULFILLED,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_ADMIN_GAME_META_REJECTED,
        payload: error.response.data
      });
      toast.error(
        <ToastMessage iconStyle="error" message="An error occurred during create Game" />
      );
    });
};

export const getAdminGame = (id) => (dispatch) => {
  dispatch({ type: GET_ADMIN_GAME_PENDING });

  return irelandApi
    .get(`${url}/games/${id}`)
    .then((response) => {
      dispatch({
        type: GET_ADMIN_GAME_FULFILLED,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_ADMIN_GAME_REJECTED,
        payload: error.data
      });
    });
};

export const getAdminGames = () => (dispatch) => {
  dispatch({ type: GET_ADMIN_GAMES_PENDING });

  return irelandApi
    .get(`${url}/games`)
    .then((response) => {
      dispatch({
        type: GET_ADMIN_GAMES_FULFILLED,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_ADMIN_GAMES_REJECTED,
        payload: error.data
      });
    });
};

export const updateGame = (id, payload) => {
  store.dispatch({ type: UPDATE_ADMIN_GAME_PENDING });
  
  return irelandApi
    .patch(`${url}/games/${id}`, prepareGameFormData(payload), config)
    .then((response) => {
      store.dispatch({
        type: UPDATE_ADMIN_GAME_FULFILLED,
        payload: response.data
      });
      toast.success(
        <ToastMessage
          iconStyle="success"
          message="Game has been saved successfully" />
      );
      history.push('/admin/games');
    })
    .catch((error) => {
      store.dispatch({ type: UPDATE_ADMIN_GAME_REJECTED, payload: error });
      toast.error(
        <ToastMessage
          iconStyle="error"
          message="Error while saving Game" />
      );
    });
};

export const saveGame = (payload) => {
  store.dispatch({ type: ADD_ADMIN_GAME_PENDING }, config);

  return irelandApi
    .post(`${url}/games`, prepareGameFormData(payload))
    .then((response) => {
      store.dispatch({
        type: ADD_ADMIN_GAME_FULFILLED,
        payload: response.data
      });
      toast.success(
        <ToastMessage iconStyle="success" message="Game created succuessfully" />
      );
      history.push('/admin/games');
      store.dispatch(actions.reset('deep.admin_game'));
    })
    .catch((error) => {
      store.dispatch({
        type: ADD_ADMIN_GAME_REJECTED,
        payload: error.response.data
      });
      toast.error(
        <ToastMessage iconStyle="error" message="An error occurred during create Game" />
      );
    });
};

export const getGameBackgroundUrl = () => (dispatch) => {
  dispatch({ type: GET_GAME_BACKGROUND_URL_PENDING });

  return irelandApi
   .get('/api/games/game_background_url')
   .then((response) => {
      dispatch({
        type: GET_GAME_BACKGROUND_URL_FULFILLED,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_GAME_BACKGROUND_URL_REJECTED,
        payload: error.data
      });
    });
}


// WEBPACK FOOTER //
// ./src/actions/games.js